import { StockModuleSettingsParms } from './../../shared/search-params';
import { Injectable } from '@angular/core';
import { HttpGeneralService, StockParms, CashierParms, SimpleStockParms, SharedDateService } from '../../shared/shared';

import { RegPatEpisode, RegPatVisit, TherapeuticCards } from '../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';

import { ApprovalRequest } from "../../approvals/index"
import { CONFIG } from '../../shared/config';
import * as urls from '../../../setting/url.json';
import { CallBeneficiary } from '../../call-center/call-center-reservation';
import { UntypedFormGroup } from '@angular/forms';
import { StockHelper } from '../../stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/stock-outpatient.helper';
import { EmrPatGlassCard } from '../../medical-recored/medical-recored.interfaces';

let stockTransUrl = CONFIG.baseUrls.StockTrans;
let rxUrl = CONFIG.baseUrls.rx;
let SecLoginsUrl = CONFIG.baseUrls.SecUserLogins; 
//===============================================================Gouhar==============================/////


export interface StockTransMaster {
  tranSerial: number;
  storeCode: number;
  transType: number;
  totalCost: number;
  totalSale: number;
  transDate: Date;
  supplierCode: number;
  clientCode: number;
  billNo: number;
  handNumber?: string;
  location?: string;
  dollarRate?: number;
  anotherSettlement?: number;
  transStatus?: number;
  causeOfReflux?: number;
  notes?: string;
  supplierBillValue?: number;
  beneficiaryStore?: number;
  parentTransId?: number;
  depCode?: number;
  empCode?: number;
  benfBranch?: number;
  exchangeCode?: number;
  updateStatus?: number;
  customerSerial?: number;
  visitSerial?: number;
  patSerial?: number;
  docSerial?: number;
  episodeSerial?: number;
  contractSerial?: number;
  exchangeServiceAccess?: number;
  deleveryEmpCode?: number;
  comingFrom?: number;
  serviceSerial?: number;
  examinationSupCode?: number;
  permissionCode?: number;
  stockTransMasterBufferSerial?: number;
  selectedTabIndex?: number;
  cf_ContractsCode?: number;
  discount: number;
  discountType: number;
  poTotalTaxMoney: number;
  totalNetCost: number;
  discountInclusion: number;
  masterAdditionalDiscountOutTax: number;
  masterAdditionalDiscountType: number;
  identityValue: string;
  identityType: number;
  vatTotalTaxes: number;
  cyl: string;
  sph: string;
  inventoryByPatch: number;
  requestNeedCode: number;
  suspensionSerial: number;
  unsubordinatForTax: number;
}
//===============================================Gouhar==============================/////

export interface StockTransDetail {
  serial: number
  tranSerial: number;
  itemCode: number;
  itemCodeForSupplier: number;
  count: number;
  unitCode: number;
  unitCost: number;
  unitSale: number;
  totalCost: number;
  totalSale: number;
  expirationDate: Date;
  smallUnitCode: number;
  countBySmallUnit: number;
  additionTransCode: number;
  allBalanceForGard: number;
  detailExchangeSerial: number;
  taxNature: number;
  discount: number;
  discountType: number;
  additionalDiscount: number;
  additionalDiscountType: number;
  tax: number;
  taxType: number;
  gift: any;
  havePatches: number;
  rxFlage?: number;
  rxStoreItemSerial?: number;
  balanceAfterTrans?: number;
  examinationSupplyCode?: number;
  smalUnitCost?: number;
  smalUnitSale?: number;
  detailOldSerial?: number;
  patchCodeOld?: string;
  composite?: number;
  permissionCode?: number;
  unitPrice?: number;
  itemPlaceAr?: string;
  itemPlaceEn?: string;
  selectedTabIndex?: number;
  patchCode?: string;
  patchCodeStr?: string;
  qRCode?: string;
  ellyNumber?: string;
  itemType?: number;
  disposed?: number;
  updateBarcode?: number;
  barcode?: string;
  itemtaxMoney: number;
  itemNameAr?: string;
  itemNameEn?: string;
  visitSerial?: string;
  isActiveMaterial?: number;
  vatValue?: number;
  donationDate?: Date;
  quantityLargeUnit?: number;
  PatchCodeOld?: number;
  vatTax?: number;
  supplierCode?: number;
  derived?: number;
}
//============================================================Gouhar==============================/////

export interface StockTransBalance {

  serial: number
  storeCode: number;
  itemCode: number;
  balance: number;
  smallUnitCode: number;
  smallUnitCost: number;
  smallUnitSale: number;
  smallUnitTotalSale: number;
  patchCode: string;
  patchCodeStr: string;
  qRCode: string;
  detailSerial: number;
  expirationDate: Date;
  stockTraParentPatch: number;
  patchUnitCode: number;
  taken: number;
  dataStatus: number;
  detailOldSerial?: number;
  unitCode?: number;
  transferfromstore: number;
}


export interface TransferStoreTrans {

  regPatVisit?: RegPatVisit;
  therapeuticCards?: TherapeuticCards;
  regPatEpisode?: RegPatEpisode;
  callBeneficiary?: CallBeneficiary;
  emrPatGlassCard?: EmrPatGlassCard;
  approvals?: ApprovalRequest[];
  stockTransMaster?: StockTransMaster[];
  stockTransDetail?: StockTransDetail[];
  stockTransDetailForAdd?: StockTransDetail[];
  stockTransBalance?: StockTransBalance[];
  derivedItems?: DerivedItems[];
  stockTransBarCodes?: stockTransBarCodes[];
}
export interface TransferStoreTransComposite {
  stockTransMasterExchange?: StockTransMaster[];
  stockTransMasterAddCompose?: StockTransMaster[];
  stockTransDetailExchange?: StockTransDetail[];
  stockTransDetailAddCompose?: StockTransDetail[];
  stockTransBalanceExchange?: StockTransBalance[];
  stockTransBalanceAddCompose?: StockTransBalance[];
}

export interface TransferStoreAddOrReturnCost {
  stockTransMaster?: StockTransMaster[];
  stockTransDetail?: StockTransDetail[];
}
export interface directAddObj {
  serial?: number;
  serialOfDirectAdd?: string;
  handNumber?: string;
  jsonMaster?: string;
  jsonDetails?: string;
  jsonMasteritemUnits?: string;
  dataStatus?: number;
  examinaionCode?: number;
  poOrderCode?: number;
  supplierCode?: number;
  stocktype?: number;
}
export interface stockTransBarCodes {
  itemCode: number;
  barCodes: string;
}

export interface PrintParms {
  storeCode?: number;
  htmlContent?: string;
  printType?: number;
  tranSerial?: number;
  preparePrintPath?: string;
  transPrintPath?: string;
}

export interface DerivedItems {
  balanceSerial?: number;
}
export interface ItemUnits {
  unit: string;
  factor: number;
}
//==================================general service in stock=============================/////

@Injectable({
  providedIn: 'root'
})
export class GenStockTransService {
  constructor(
    private httpGeneralService: HttpGeneralService,
    public _StockHelper: StockHelper,
    private _dateService: SharedDateService) { }


  getSupplierName(_StockParms: StockParms) {
    return this.httpGeneralService.add(_StockParms, `${stockTransUrl}/getSupplierName`)
  }

  updateSupplierName(supplierData: StockParms[]) {
    return this.httpGeneralService.addCollection(supplierData, `${stockTransUrl}/updateSupplierName`);
  }

  printOnServer(printParms: PrintParms[]) {
    return this.httpGeneralService.addCollection(printParms, `${stockTransUrl}/PrintOnServer`)
  }
  addStockTransactionSuspension(directAddObj: directAddObj) {
    return this.httpGeneralService.add(directAddObj, `${stockTransUrl}/directAddObj`);
  }

  getUnitsByItemId(itemCode: number) {
    return this.httpGeneralService.get(itemCode, stockTransUrl);
  }

  getItemsByTransCodes(TransCodes: number) {

    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsByTransCodes/${TransCodes}`);
  }
  OpenBalncePrint(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/OpenBalncePrint`);
  }

  getItemsPatches(itemCode: number, storeCode: number, transferQuan: number, cfClientType?: number) {
    if (!cfClientType)
      cfClientType = 0;
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsPstches/${itemCode}/${storeCode}/${transferQuan}/${cfClientType}`)
  }

  getAllItemsPatches(stockParms: StockParms) {
    return this.httpGeneralService.post(stockParms, `${stockTransUrl}/getItemsPstches`)
  }

  getItemsInventoryPatches(itemCode: number, storeCode: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsIventoryPstches/${itemCode}/${storeCode}`)
  }

  getItems(itemCodes: string) {

    return this.httpGeneralService.getWith(`${stockTransUrl}/${itemCodes}`)
  }
  getItemsData(_StockParms: StockParms) {
    return this.httpGeneralService.post(_StockParms, `${stockTransUrl}/GetItemsData`);
  }

  getsaleItemsByProfitList(items: StockParms[]) {
    return this.httpGeneralService.post(items, `${stockTransUrl}/ItemsProfitMargin`)
  }

  checkForItemInBalance(itemCodes: any, storeCode: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsPstches/${itemCodes}/${storeCode}`)
  }
  executeInventoryJournal(transerial: number) {
    return this.httpGeneralService.add<any>(transerial, `${stockTransUrl}/inventoryJournal`)
  }
  transfereTtemFromStore(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add<TransferStoreTrans>(transferStoreTrans, stockTransUrl);
  }

  transfereTtemFromStoreForBloodBank(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add<TransferStoreTrans>(transferStoreTrans, `${stockTransUrl}/transfereTtemFromStoreForBloodBank`);
  }
  transItemStoreByPatch(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add<TransferStoreTrans>(transferStoreTrans, `${stockTransUrl}/transfereItemStoreByPatch`);
  }
  PostTransferStockByPatch(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add<TransferStoreTrans>(transferStoreTrans, `${stockTransUrl}/transferStockByPatch`);
  }
  StockTransCompositeSaveAndNew(transferStoreTransComposite: TransferStoreTransComposite) {
    return this.httpGeneralService.add<TransferStoreTransComposite>(transferStoreTransComposite, `${stockTransUrl}/StockTransCompositeSaveAndNew`);
  }
  CancelStockTransCompositeSave(cancelTransferStoreTransComposite: StockTransMaster) {
    return this.httpGeneralService.add<StockTransMaster>(cancelTransferStoreTransComposite, `${stockTransUrl}/CancelStockTransCompositeSave`);
  }
  StockTransMasterAddOrReturnCost(StockTransAddOrReturnCost: TransferStoreAddOrReturnCost) {
    return this.httpGeneralService.add<TransferStoreAddOrReturnCost>(StockTransAddOrReturnCost, `${stockTransUrl}/StockTransMasterAddOrReturnCost`);
  }
  itemsLoad(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/itemsLoad`);

  }
  itemsLoadByPatch(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/itemsLoadByPatch`);

  }
  createItemsBarcodes(_StockParms: SimpleStockParms[]) {
    return this.httpGeneralService.addCollection<SimpleStockParms>(_StockParms, `${stockTransUrl}/createItemsBarcodes`);

  }

  getItemBarcodes(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/getItemBarcodes`);

  }
  getItemBarcodesPrint(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${stockTransUrl}/getItemBarcodesPrint`);

  }
  itemBarcodesPrintSave(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${stockTransUrl}/itemBarcodesPrintSave`);

  }
  GetAllItemsInGroups(_StockParms: StockParms[]) {
    return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/GetAllItemsInGroups`);

  }
  itemsPrice(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${stockTransUrl}/itemsPrice`);
    //data[0]
  }


  supplierClaimsTransLoad(_StockParms: StockParms) {
    return this.httpGeneralService.add<StockParms>(_StockParms, `${stockTransUrl}/supplierClaimsTransLoad`);
    //data[0]
  }

  GetInventoryTransToConfirm(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetInventoryTransToConfirm`);
  }
  getInventoryTransactionINHOS(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllInventoryTransactions`);
  }
  getDeliveryTransList(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/SearchDeliveryTrans`);
  }

  // GetAllItemsInStore(_Sto: StockParms) {
  //   return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllItemsInStore`);

  // }

  GetAllItemsInInventory(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllItemsInInventory`);

  }
  deleteStockTrans_Inventory(_Sto: StockTransMaster) {
    return this.httpGeneralService.add<StockTransMaster>(_Sto, `${stockTransUrl}/DeleteStockTrans`);
  }

  //////+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  GetAllItemsByMasterSerial(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/GetAllItemsByMasterSerial`);
  }
  //////+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  loadRx(RxMaster: number) {
    return this.httpGeneralService.getWith(`${rxUrl}/LoadRx/${RxMaster}`)
  }
  getItemsByServiceID(ServiceId: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/ItemServiceSerach/${ServiceId}`);
  }


  AssignTyaRToTRansaction(_Sto: StockTransMaster) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/AssignTyaRToTRansaction`);
  }

  getProcessRequirmentItems(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/getProcessRequirmentPrintInfo`);
  }



  getMedicationalter(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/StrGetItemsAlterAndMatrial`);
  }

  getStockModuleSettings(parms: StockModuleSettingsParms) {
    return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }

  ////----------------------------------buffer--------------------------------
  _saveBufferForTransacion(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add(transferStoreTrans, `${stockTransUrl}/PostStockTransBuffer`);
  }
  _saveBufferForTransacionByPatch(transferStoreTrans: TransferStoreTrans) {
    return this.httpGeneralService.add(transferStoreTrans, `${stockTransUrl}/PostStockTransByPatchBuffer`);
  }

  _GetStockTransBufferd(_StockParms: StockParms) {
    return this.httpGeneralService.add(_StockParms, `${stockTransUrl}/GetStockTransBufferd`);
    //data[0]
  }



  getStockTransfereValidationfun() {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getStockTransfereValidation`);
    //data[0]
  }

  getItemsReFluxPrice(transSerial: number, selectedUnit?: number, transType?: number) {
    return this.httpGeneralService.getWith(`${stockTransUrl}/getItemsReFluxPrice/${transSerial}/${selectedUnit}/${transType}`);
  }


  //------------------------------------------------functions print -------------------
  stockTransBufferPrint(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/stockTransBufferPrint`);
  }

  stockInventoryDetailReportPrint(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/StockInventoryDetailReportPrint`);
  }

  stockInventoryTotalReportPrintSP(_Sto: StockParms) {
    return this.httpGeneralService.add(_Sto, `${stockTransUrl}/StockInventoryTotalReportPrintSP`);
  }

  GetBeneficiaries(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/Beneficiaries`);
  }
  getSecLogins(id: number) {
    return this.httpGeneralService.get(id, SecLoginsUrl);
} 
  checkItemsToSave(DirectAddTransForm: UntypedFormGroup, items: any, itemUnits: any, linkId: number, editSerial?: number): any {
    //============---------------------------
    let stockTransDetailList: any[] = [];
    let copyArr: any[] = [];
    copyArr = items;
    for (var i = 0; i < items.length; i++) {
      //============---------------validation on expiration ------------
      items = items.sort();
      if (items[i].discount == undefined || items[i].discount == null) { items[i].discount == 0 }
      if (items[i].discountType == undefined || items[i].discountType == null) { items[i].discountType == 1 }
      if (items[i].additionalDiscount == undefined || items[i].additionalDiscount == null) { items[i].additionalDiscount == 0 }
      if (items[i].additionalDiscountType == undefined || items[i].additionalDiscountType == null) { items[i].additionalDiscountType == 1 }
      if (items[i].tax == undefined || items[i].tax == null) { items[i].tax == 0 }
      if (items[i].taxType == undefined || items[i].taxType == null) { items[i].taxType == 1 }
      let stockTransDetail = <StockTransDetail>{};
      let unitValue = this._StockHelper.getUnitValue(itemUnits, items[i]['unitCode'], items[i]['code']);
      if (unitValue)
        var factor = unitValue[0]["factor"];
      stockTransDetail.serial = (i + 1) * -1;
      stockTransDetail.havePatches = 0;
      stockTransDetail.tranSerial = 1;
      stockTransDetail.itemCode = items[i].code;
      stockTransDetail.count = items[i].number;
      stockTransDetail.gift = items[i].gift;
      if (items[i].gift == (undefined || null)) {
        stockTransDetail.gift = 0;
      }
      stockTransDetail.unitCode = items[i].unitCode;
      stockTransDetail.unitPrice = items[i].unitPrice;
      stockTransDetail.unitSale = items[i].unitSale;
      stockTransDetail.patchCode = items[i].patchCode;
      stockTransDetail.patchCodeStr = items[i].patchCodeStr;
      stockTransDetail.unitCost = items[i].unitCost;
      stockTransDetail.totalCost = items[i].totalCost;
      stockTransDetail.totalSale = items[i].netOfPiceitem;
      stockTransDetail.itemPlaceAr = items[i].itemPlaceAr;
      stockTransDetail.itemPlaceEn = items[i].itemPlaceEn;
      stockTransDetail.itemtaxMoney = items[i].itemtaxMoney;
      let smaillUnitValue = this._StockHelper.getSmallUnitValue(itemUnits, items[i].code);
      if (smaillUnitValue.length > 0 && smaillUnitValue) {
        const smalUnitCode = smaillUnitValue[0]["serial"]
        stockTransDetail.smallUnitCode = smalUnitCode;
      }
      const smalUnitCost = +items[i].unitCost / factor
      stockTransDetail.smalUnitCost = smalUnitCost;
      const smalUnitSale = +items[i].unitSale / factor
      stockTransDetail.smalUnitSale = smalUnitSale;
      stockTransDetail.countBySmallUnit = factor * items[i].number; //عدد الصنف ف معامل التحويل للوحده الصغرى
      stockTransDetail.balanceAfterTrans = factor * items[i].number; //عدد الصنف ف معامل التحويل للوحده الصغرى
      if (items[i].examinationSupplyCode != (undefined || null)) {
        stockTransDetail.examinationSupplyCode = items[i].examinationSupplyCode;
      }
      let expirationDate = this._dateService.convertFromNgBsToDate(items[i].expirationDate);
      stockTransDetail.expirationDate = expirationDate;
      stockTransDetail.discount = items[i].discount;
      stockTransDetail.discountType = items[i].discountType;
      stockTransDetail.additionalDiscount = items[i].additionalDiscount;
      stockTransDetail.additionalDiscountType = items[i].additionalDiscountType;
      stockTransDetail.tax = items[i].tax;
      stockTransDetail.taxType = items[i].taxType;
      if (items[i].discountType == undefined || items[i].discountType == null) {
        items[i].discountType == 1
      }
      if (items[i].additionalDiscountType == undefined || items[i].additionalDiscountType == null) {
        items[i].additionalDiscountType == 1
      }
      if (items[i].taxType == undefined || items[i].taxType == null) {
        items[i].taxType == 1
      }
      stockTransDetail.supplierCode = DirectAddTransForm.get('supplierCode').value;//abdo2042022
      stockTransDetailList.push(stockTransDetail);
    }
    //===================master=================== 
    let stockTransMasterList: any[] = [];
    let stockTransMaster = <StockTransMaster>{};
    stockTransMaster = DirectAddTransForm.value;   // wanted
    stockTransMaster["tranSerial"] = -1;
    stockTransMaster["transType"] = 2;

    if (linkId == 9892 || linkId == 9893) {
      // اضافة بضاعه امانه لمورد
      stockTransMaster["transType"] = 24;
    }
    let transDate = this._dateService.convertFromNgBsToDate(DirectAddTransForm.get('transDate').value);
    stockTransMaster["transDate"] = transDate;
    stockTransMaster["totalCost"] = DirectAddTransForm.get('totalCost').value;
    stockTransMaster["totalSale"] = DirectAddTransForm.get('totalSale').value;
    stockTransMaster["poTotalTaxMoney"] = DirectAddTransForm.get('poTotalTaxMoney').value;
    stockTransMaster['suspensionSerial'] = editSerial;
    //======================================
    stockTransMasterList.push(stockTransMaster);
    let stockTransBalanceList: any[] = [];
    //======================================
    if (stockTransDetailList.length == 0) {
      return false;
    }
    let oenBalanceOfItem = <TransferStoreTrans>{};
    oenBalanceOfItem.stockTransMaster = stockTransMasterList;
    oenBalanceOfItem.stockTransDetail = stockTransDetailList;
    oenBalanceOfItem.stockTransBalance = stockTransBalanceList;
    return oenBalanceOfItem;

  }
}
let cashiertransUrl = CONFIG.baseUrls.cashierTrans;
